<template>
    <div class="tab-buttons">
        <b-button
            v-for="tab in tabs"
            :key="tab"
            variant="tab"
            :pressed="activeTab === tab"
            :title="tab === 'blast_info' ? 'Coming soon' : ''"
            @click="emitTabChange(tab)"
        >
            <span v-if="tab === 'annotated_events'" class="overly-button-div">
                <b-button
                    v-b-tooltip.hover
                    class="overly-button"
                    :title="$translate('view_event_images')"
                    :disabled="!showOverlayModal"
                    @click.stop="openOverlayModal"
                >
                    <i class="fa fa-th-large"></i>
                </b-button>
                <i class="fa fa-bars annotated-icon"></i>
                <span class="text-div">{{ $translate(tab) }}</span>
            </span>
            <template v-else>{{ $translate(tab) }}</template>
        </b-button>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import UIUtils from '../../../business/utils/UIUtils'
import Utils from '../../../business/utils/Utils'

export default {
    name: 'TabButtons',
    props: {
        tabs: {
            type: Array,
            required: true
        },
        activeTab: {
            type: String,
            required: true
        }
    },
    computed: {
        ...mapGetters({
            getWellIndexByWellId: 'timelapse/getWellIndexByWellId'
        }),
        ...mapState({
            focusedWell: state => state.timelapse.focusedWell
        }),
        showOverlayModal() {
            return Utils.hasEventsForOverlayModal(this.focusedWell)
        }
    },
    methods: {
        emitTabChange(tabName) {
            if (tabName === this.activeTab) return

            this.$log.actionEvent('small_screen_focused_well_tab_change', tabName)
            this.$emit('tabChanged', tabName)
        },
        openOverlayModal() {
            UIUtils.showModal('images_overlay', data => {
                data.well = {
                    ...this.focusedWell,
                    wellIndex: this.getWellIndexByWellId(this.focusedWell._id)
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.tab-buttons {
    height: #{$tabs-height};
    width: 100%;
    display: flex;
    padding: 0 1rem;

    button {
        flex: 1 1 0;
        width: 0;
    }
    .overly-button-div {
        display: flex;
        align-items: center;

        .overly-button {
            max-width: 1rem;
            padding: 0;
            background-color: transparent !important;
            display: flex;

            &:hover {
                color: white;
            }
        }
        .annotated-icon {
            margin-left: 0.5rem;
        }
        .text-div {
            flex: 1;
        }
    }

    @media screen and #{$new-break4close} {
        .btn.btn-tab {
            font-size: 10pt;
            padding-top: 0.7rem;
            border-width: 0.2rem !important;

            &:not(.active) {
                border: none !important;
            }
        }

        @media screen and #{$new-break2close} {
            background-color: $dark-4;
        }
        @media screen and #{$new-break3}, #{$new-break4} {
            background-color: $dark;
        }
    }
}
</style>
